var exports = {
  "kL": "MobileBottomNav.module__container___c0t2Sl",
  "oi": "MobileBottomNav.module__navButton___c0t2Sl",
  "Mv": "MobileBottomNav.module__navButtonActive___c0t2Sl",
  "XA": "MobileBottomNav.module__navButtonInactive___c0t2Sl",
  "VK": "MobileBottomNav.module__voiceButton___c0t2Sl",
  "Kk": "MobileBottomNav.module__icon___c0t2Sl",
  "Pf": "MobileBottomNav.module__label___c0t2Sl",
};

module.exports = exports;
